export const SCAN_INTEGRATION_FORM_MESSAGE =
  "This integration will be used to run a scan. Without Assume role on worker enabled, the scan's credentials are limited to a 1-hour session — enable it to allow sessions of up to 12 hours.";
